import type { FunctionComponent } from 'react';
import { useEffect } from 'react';

import { useFormattedBalanceConnected } from '../../../hooks/useFormattedBalanceConnected';
import { useNetPositionConnected } from '../../../hooks/useNetPositionConnected';
import { useBonusBalanceConfig } from '../../../store/compositeSelectors/useBonusBalanceConfig';
import { useCompositeBalance } from '../../../store/compositeSelectors/useCompositeBalance';
import { useCoreDispatch } from '../../../store/CoreStore';
import { useBetSlice } from '../../../store/slices/bets/selectors';
import { useConfigSlice } from '../../../store/slices/config/selectors';
import { useGameStateSlice } from '../../../store/slices/game/selectors';
import { useTrophyIcon } from '../../../store/slices/promotions/selectors';
import { promotionActions } from '../../../store/slices/promotions/slice';
import { CurrencyConnected } from '../../currency/CurrencyConnected';
import { L12nText } from '../../text/L12nText';

import { GameFooter } from './gameFooter';

export const GameFooterConnected: FunctionComponent = () => {
  const gameId = useGameStateSlice.gameId();
  const balance = useCompositeBalance();
  const totalBet = useBetSlice.totalBet();
  const tableName = useConfigSlice.tableName();
  const tableConfig = useConfigSlice.tableConfig();
  const tableBetLimits = useConfigSlice.tableBetLimits();
  const net = useNetPositionConnected();
  const compliance = useConfigSlice.compliance();
  const trophy = useTrophyIcon();
  const dispatch = useCoreDispatch();
  const sessionIDs = compliance?.showSessionId
    ? { aamsTicket: tableConfig?.aamsTicket || '', aamsSessionId: tableConfig?.aamsSessionId || '' }
    : null;
  const formattedBalance = useFormattedBalanceConnected();

  useEffect(() => {
    if (trophy.showTrophyTooltip && trophy.visibility === 'inactive') {
      dispatch(promotionActions.changeShowTrophyTooltip(false));
    }
  }, [trophy.visibility]);
  const displayBonusBalance = useBonusBalanceConfig();

  if (!tableName || !tableBetLimits || !balance || !gameId) {
    return null;
  }
  return (
    <GameFooter
      balance={formattedBalance}
      bonus={displayBonusBalance ? <CurrencyConnected value={balance.bonus} /> : null}
      net={net !== undefined ? <CurrencyConnected value={net} /> : null}
      totalBet={<CurrencyConnected value={totalBet} />}
      tableName={<L12nText tk={tableName} />}
      tableBetLimits={[
        <CurrencyConnected value={tableBetLimits.min} key={0} avoidTrailingZero />,
        <CurrencyConnected value={tableBetLimits.max} key={1} avoidTrailingZero />,
      ]}
      sessionIDs={sessionIDs}
      showSessionTimer={compliance?.showSessionTimer || false}
      gameId={gameId}
      trophy={trophy}
    />
  );
};
